import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PermissionsService } from './permissions.service';

@Injectable({
  providedIn: 'root'
})
export class ExamViolationsService {

  private apiUrl = 'https://exam.alarkkan.app/api/api/call'; // From ExamApp

  constructor(private http: HttpClient,private permissionsService: PermissionsService) { }

  getCandidatesCurrentlyTesting(): Observable<any>{
      const body = {
      procedureName: 'getCandidatesCurrentlyTesting',
      params: {}
    };
    return this.http.post<any>(this.apiUrl, body, { headers: { 'Content-Type': 'application/json' } });
  }

createNewViolationReport(violationReport: any): Observable<any> {
  const body = {
    procedureName: 'createNewViolationReport',
    params: {
      IDNumber: violationReport.IDNumber,
      TraineeName: violationReport.TraineeName,
      BookingId: violationReport.BookingID,
      BookingType: violationReport.BookingType,
      PhoneNumber: violationReport.PhoneNumber,
      Gender: violationReport.Gender,
      CourseID: violationReport.CourseID,
      CourseName: violationReport.CourseName,
      LanguageName: violationReport.LanguageName,
      ExamAttendanceNo: violationReport.ExamAttendanceNo,
      StartExamDate: violationReport.StartExamDate,
      ExamResult: violationReport.ExamResult,
      BranchCity: violationReport.CityName,
      BranchID: violationReport.BranchID,
      CreateDate: violationReport.currentDate,
      CreatedBy: this.permissionsService.getUserId(),
      ExamSupervisorName: violationReport.supervisorName,
      ExamSupervisorEmail: violationReport.supervisorEmail, 
      ExamInvigilatorName: violationReport.examInvigilatorName,
      IncidentInformation: violationReport.incidentInformation,
      ActionTaken: violationReport.actionTaken
    }
  };
  return this.http.post<any>(this.apiUrl, body, { headers: { 'Content-Type': 'application/json' } });
}


  getTodayExamViolations(): Observable<any>{
      const body = {
      procedureName: 'getTodayExamViolations',
      params: {}
    };
    return this.http.post<any>(this.apiUrl, body, { headers: { 'Content-Type': 'application/json' } });
  }

}
